import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export const autoSplit = (name) => {
    const p = String(name || "").trim().split(/\s+/).filter(Boolean);
    return p.length > 1 ? [p.slice(0, -1).join(" "), p[p.length - 1]] : ["", p[0] || ""];
};

export const fetchSplits = () => api.get("/players/name-splits").then((r) => r.data);

// [first, last] for a player — the owner's manual split (Player admin) wins over the auto last-word split.
export function useNameSplit() {
    const { data = {} } = useQuery({ queryKey: ["name-splits"], queryFn: fetchSplits, staleTime: 5 * 60 * 1000 });
    return (name, id) => (id && data[id]) || autoSplit(name);
}
